export default __webpack_public_path__ + "static/logo-group-15f4bcf26a7df1a60cd3418f38923197.svg";